export default function BOT_GiftSet() {
    var data = {};

    const selectors = {
        // step1: ".page-step-1",
        // step2: ".page-step-2",
        // step3: ".page-step-3",
        loading: ".load-more-waiting",
        stepPage: ".gift-set-step-page .select-page",
        finalStep: ".gift-set-step-page .final-step",
        hideClass: "hidden-page",
        btnSelected: ".select-page .step-section .selected-button", //'.select-page .selected-button',
        btnBackToGift: ".final-step .back-to-gift",
        btnBackStep: ".select-page .back-step",
        btnGoFinalPage: ".select-page .go-final-page",
        finallyStepIndex: jQuery('.gift-set-step-page .page-step.final-step').index(),
        lastShowClass: "last-showed",
        currentStepClass: "current-page",
    };

    this.init = () => {
        c7.addAction("c7_side_cart_rendered", (content) => {
            cartHideScroll();
        });
        c7.addAction("c7_add_to_cart_detail_page_rendered", (content) => {
            giftsetBundleRender();
        });

        if (!document.querySelector(".gift-set-step-page")) {
            return;
        }
        // closePopup();
        selectedItems();
        addCartGiftSet();
        jQuery(selectors.btnBackToGift).click(function () {
            switchStepPage(-1);
        });
        jQuery(selectors.btnGoFinalPage).click(function () {
            switchStepPage(1);
        });
        jQuery(selectors.btnBackStep).click(function () {
            let current = jQuery(this).data("current");
            switchStepPage(-1);
            delete data[current];
            processItems();
        });
    };

    // const closePopup = () => {
    //   jQuery('.popup-notification').on('click', function(e) {
    //     // if (e.target === this || jQuery(e.target).closest('.close-popup').length) {
    //     if (jQuery(e.target).closest('.close-popup').length) {
    //       jQuery(this).remove();
    //     }
    //   });
    // }
    // stepNo is 1 if next step and -1 if back step
    const switchStepPage = (stepNo = 1) => {
        var pageShowedIndex = jQuery('.gift-set-step-page .page-step.current-page').index();
        var nextStep = pageShowedIndex + stepNo;

        if (0 <= nextStep && nextStep <= selectors.finallyStepIndex) {
            jQuery('.gift-set-step-page .page-step').eq(pageShowedIndex).addClass(
                selectors.hideClass
            ).removeClass(`${selectors.currentStepClass} ${selectors.lastShowClass}`);


            jQuery('.gift-set-step-page .page-step').eq(nextStep).removeClass(
                selectors.hideClass
            ).addClass(`${selectors.currentStepClass} ${selectors.lastShowClass}`);
        }
    }

    const selectedItems = () => {
        if (document.querySelector(".gift-set-step-page")) {
            jQuery(selectors.btnSelected).click(function () {
                var item = jQuery(this).closest(".select-page").data("item");
                var slug = jQuery(this).data("slug");
                var price = Number(jQuery(this).data("price"));
                var title = jQuery(this).data("title");
                var image = jQuery(this).data("image");
                var id = jQuery(this).data("id");
                var variant = jQuery(this).data("variant");

                data[item] = { id, item, slug, price, title, image, variant };
                processItems();
                renderFinalHTML();
                animateScroll();
                switchStepPage(1);
            });
        }
    };

    const processItems = () => {
        if (document.querySelector(".select-page")) {
            let percent =
                (Object.keys(data).length / Number(jQuery(".select-page").length)) *
                100;
            jQuery(".step-process-item").css("width", percent + "%");
            if (Object.keys(data).length > 0) {
                jQuery(selectors.btnSelected).removeClass("selected");
                for (const key in data) {
                    if (Object.hasOwnProperty.call(data, key)) {
                        const element = data[key];
                        jQuery(
                            ".select-page." +
                            key +
                            ' button[data-slug="' +
                            element.slug +
                            '"]'
                        ).addClass("selected");
                    }
                }
            }
        }
    };

    const renderFinalHTML = () => {
        let price = 0;
        let listProduct = "";
        let imageGroup = "";
        let _length = Object.keys(data).length;

        if (_length > 0) {
            for (const key in data) {
                if (Object.hasOwnProperty.call(data, key)) {
                    const element = data[key];
                    listProduct += "<h5>" + element.title + "</h5>";
                    price += Number(element.price);
                    imageGroup +=
                        '<div class="image-item"><img src="' +
                        element.image +
                        '" alt="' +
                        element.title +
                        '"></div>';
                    jQuery(selectors.stepPage + " .back-step").removeClass(
                        selectors.hideClass
                    );
                }
            }

            jQuery(".gift-set-step-page .list-name").html(listProduct);
            jQuery(".gift-set-step-page .total-price").html("$" + price);
            jQuery(".gift-set-step-page .group-image").html(imageGroup);
        }
    };

    const addCartGiftSet = () => {
        if (document.querySelector(".final-content")) {
            jQuery(".final-content .add-cart-gift-set .add-giftset-cart").click(
                function () {
                    createGiftSetBundle();
                }
            );
        }
    };
    const cartHideScroll = () => {
        const targetNode = document.getElementById('c7-side-cart');
        const callback = mutations => {
            if (targetNode.classList.contains('c7-side-cart--visible')) {
                if (window.screen.width <= 550) {
                    jQuery('body').addClass('overflow-hidden');
                } else {
                    jQuery('body').removeClass('overflow-hidden');
                }

                jQuery('.c7-order-item__description').each(function (i, e) {
                    jQuery(e).html('<ul><li>' + jQuery(e).text().split("---").join('</li><li>') + '</ul></li>');
                })

            } else {
                jQuery('body').removeClass('overflow-hidden');
            }
        }

        const observer = new MutationObserver(callback);

        observer.observe(targetNode, { attributes: true, childList: true, characterData: true });
    }

    const giftsetBundleRender = () => {
        jQuery('.c7-form.c7-product__add-to-cart .c7-product__add-to-cart__price .c7-product__add-to-cart__price__variant .c7-product__variant__price__title').each(function (i, e) {
            if (jQuery(e).text().split("---").length > 1) {
                jQuery(e).html('<ul><li>' + jQuery(e).text().split("---").join('</li><li>') + '</ul></li>');
                jQuery(e).closest('.c7-product__add-to-cart__price').addClass('removeSlash');
            }
        })
    }

    const animateScroll = () => {
        var body = jQuery("html, body");
        body.stop().animate({ scrollTop: 0 }, 800, "swing", function () { });
    };

    const controlLoading = (status) => {
        if ("open" === status) {
            document.querySelector(selectors.loading).classList.add("loading");
            document.querySelector(".notification").classList.add("show");
        } else {
            document.querySelector(selectors.loading).classList.remove("loading");
            document.querySelector(".notification").classList.remove("show");
        }
    };

    const renderAPIData = () => {
        var apiData = {
            price: 0,
            images: [],
            bundleItems: [],
            titles: ["Gift Box "],
            giftMessage: jQuery('#gift-message').val()
        };

        let price = 0;
        let _length = Object.keys(data).length;
        if (_length > 0) {
            let i = 1;
            for (const key in data) {
                if (Object.hasOwnProperty.call(data, key)) {
                    const element = data[key];
                    price += Number(element.price);
                    apiData.bundleItems.push({
                        productVariantId: element.variant,
                        quantity: 1,
                    });

                    apiData.images.push({
                        sortOrder: i + 1,
                        src: element.image,
                    });

                    apiData.titles.push(element.title);
                }

                apiData.price = price;
                i++;
            }
        }
        return apiData;
    };

    const createGiftSetBundle = () => {
        let apiData = renderAPIData();
        jQuery.ajax({
            type: "POST",
            dataType: "json",
            url: theme_object.ajax_url,
            data: {
                apiData,
                // background,
                action: "create_gift_set_bundle",
                pageID: jQuery('input[name="page-id"]').val()
            },
            beforeSend: function () {
                controlLoading("open");
            },
            success: function (response) {
                if (200 == response.code) {
                    let addToCartUrl =
                        window.location.origin +
                        window.location.pathname +
                        "?addToCart=" +
                        response.sku;
                    window.location.href = addToCartUrl;
                } else {
                    console.log("Can't create bundle by API");
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log("The following error occured: " + textStatus, errorThrown);
            },
        });
    };
}
